import DonutChart from 'components/DonutChart';

import { COLOR_MAP, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const DroneHealthChart: FunctionComponent<Props> = ({
    className = '',
    testId = TEST_ID,
    text,
    value
}) => (
    <DonutChart
        className={className}
        colorMap={COLOR_MAP}
        label={text}
        percent={value}
        testId={testId}
    />
);

export default DroneHealthChart;
